import { Tabs } from "@narmi/design_system";
import { EMPTY_QUERY, ThreadQuery, THREAD_TABS, ThreadTab } from "./types";
import { useUserConfiguration } from "@hooks/useUserConfiguration";
import { statusToLabel } from "./threadUtil";

export function MessageTabs({
  selectedTab,
  setSelectedTab,
  setFilters,
}: {
  selectedTab: ThreadTab;
  setSelectedTab: (state: ThreadTab) => void;
  setFilters: (filters: ThreadQuery) => void;
}) {
  const { currentUser } = useUserConfiguration();
  const appliedTabs = THREAD_TABS.filter((tab) => {
    if (tab === "assigned_to_my_team")
      return currentUser.support_teams && currentUser.support_teams.length > 0;
    return true;
  });

  return (
    <Tabs
      selectedIndex={appliedTabs.indexOf(selectedTab) || 0}
      onTabChange={(tabIndex: number) => {
        setSelectedTab(appliedTabs[tabIndex]);
        setFilters(EMPTY_QUERY);
      }}
    >
      <Tabs.List>
        {appliedTabs.map((tab) => (
          <Tabs.Tab
            key={tab}
            label={statusToLabel(tab, currentUser.support_teams?.length)}
            tabId={tab}
          />
        ))}
      </Tabs.List>
    </Tabs>
  );
}
